import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
	console.warn(
		"VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY not configured — auth will be disabled.",
	);
}

export const supabase = createClient(url || "", anonKey || "", {
	auth: {
		persistSession: true,
		autoRefreshToken: true,
		detectSessionInUrl: true,
		storageKey: "gout-food-scanner.supabase.auth",
		flowType: "pkce",
	},
});
